<ngx-smart-modal #myModal1 identifier="myModal1">
  <h2 class="modalError">Please login and subscribe to access this content.</h2>
  <button
    class="modalErrorButton"
    (click)="myModal1.close()"
    routerLink="/login"
  >
    Login Now
  </button>
</ngx-smart-modal>
<ngx-smart-modal #myModal2 identifier="myModal2">
  <h2 class="modalError">
    Oh No, something went wrong, please refresh the page.
  </h2>
  <button class="modalErrorButton" (click)="myModal2.close(); refresh()">
    Refresh Now
  </button>
</ngx-smart-modal>
<div class="loadingBoxOrange">
  <section class="login-main-wrapper full-height">
    <div class="container-fluid pl-0 pr-0">
      <div class="row no-gutters row justify-content-center ">
        <div class="col-md-5 p-5 bg-dark-style authbox">
          <div class="login-main-left">
            <div class="text-center mb-5 login-main-left-header">
              <img
                src="assets/img/hostbrand/core-whitelogo.svg"
                width="300"
                class="img-fluid"
                alt="LOGO"
              />
            </div>

            <div class="text-center">
              <br /><br />
              <h3 class="pulsate">Welcome, let's get going!</h3>
              <div class="text-center" style="margin-top: 30px;">
                <button  (click)="autoLogin()" class="form-control">
                  <a
                  href="javascript:;"
                    ><span>Explore Now</span></a
                  ></button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
